module.exports = __webpack_public_path__ + "img/CATEGORY ICON-10.ca9588cf.png";